export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PostShare.vue?vue&type=template&id=64d2b8a5&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PostShare.vue?vue&type=template&id=64d2b8a5&scoped=true&
// module id = 302
// module chunks = 0